module.exports = "<div fxLayout=\"column\">\r\n\r\n    <crew-person-details [person]=\"person\"\r\n                         [dateOfBirth]=\"DateOfBirth\"\r\n                         [isReadonly]=\"true\">\r\n    </crew-person-details>\r\n\r\n    <div fxLayout=\"column\">\r\n        <crew-edit-buttons (onEdit)=\"edit()\"\r\n                           (onDelete)=\"delete()\"\r\n                           (onBackToList)=\"backToList()\">\r\n        </crew-edit-buttons>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/resources/persons/details/person.component.html
// module id = 1316
// module chunks = 1